import EnhancedAttendanceManagement from './EnhancedAttendanceManagement'
// Upload-related imports commented out since bulk upload is disabled
// import {uploadAttendenceFile} from '../../../api/AttendanceAPI'
// import {Modal} from 'react-bootstrap'
// import CustomFileInput from '../../components/CustomInput/CustomFileInput'

const AmsLayout = () => {
  // All state and logic now handled by EnhancedAttendanceManagement component
  
  // Tab switching function - commented out since tabs are hidden
  /* const handleTabClick = (tab) => {
    setActiveTab(tab)
    getRecords(
      `${API.ATTENDENCE}?startDate=${formattedDate}&userId=${currentUser?.id}&preset=${tab}`,
      setAttendence
    )
  } */
  // useEffect commented out since Enhanced Attendance Management handles its own data loading
  /* useEffect(() => {
    let mounted = true
    if (mounted) {
      getRecords(
        `${API.ATTENDENCE}?startDate=${formattedDate}&userId=${currentUser?.id}&preset=${activeTab}`,
        setAttendence
      )
    }
    return () => {
      mounted = false
    }
  }, []) */
  return (
    <div>
      {/* Upload modal hidden since Enhanced Attendance Management has its own upload functionality */}
      {/* Upload modal commented out since bulk upload is disabled */}
      {/* <Modal show={showForm} animation={false} backdrop='static' centered>
        <div className='modal-header'>
          <h2 className='fw-bolder'>Upload Attendence File</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              cancelSubmit(setFormField, () => {}, setInputError, {file: null}, setShowForm)
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='row ms-3'>
            <div className='fv-row me-6 col-md-5 col-6 mb-3'>
              <CustomFileInput
                name='file'
                value={formField.file}
                onChange={(event) =>
                  handleOtherInputChange(event, 'file', setFormField, inputError, setInputError)
                }
                label='File'
                id='file'
                error={inputError.file}
              />
            </div>
          </div>
          <SubmitCancleButton
            cancle={{
              onClick: () => {
                cancelSubmit(setFormField, () => {}, setInputError, {file: null}, setShowForm)
              },
            }}
            submit={{
              editid: null,
              loading: submitAPIStatus.loading,
              onClick: () =>
                handleFileSubmit(
                  `${API.ATTENDENCE}?startDate=${formattedDate}&userId=${currentUser?.id}&preset=${activeTab}`,
                  formField,
                  {file: null},
                  setAttendence,
                  () => {},
                  setFormField,
                  null,
                  setInputError,
                  validateForm,
                  setSubmitAPIStatus,
                  uploadAttendenceFile,
                  setShowForm
                ),
            }}
          />
        </div>
      </Modal> */}
      {/* Tab navigation hidden as requested - always show Enhanced Attendance */}
      {/* <div className='row'>
        <div
          // id='kt_toolbar_container'
          className={clsx('d-flex justify-content-between card ps-5 mb-4')}
        >
          <div className='d-flex h-55px '>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <Link
                  className={clsx('nav-link text-active-primary me-4', {
                    active: activeTab === 'enhanced',
                  })}
                  to=''
                  onClick={() => setActiveTab('enhanced')}
                >
                  Enhanced Attendance (CRUD)
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  className={clsx('nav-link text-active-primary me-4', {
                    active: activeTab === 'self',
                  })}
                  to=''
                  onClick={() => handleTabClick('self')}
                >
                  My Attendence (Legacy)
                </Link>
              </li>

              {currentUser?.isRmOrHr && (
                <li className='nav-item'>
                  <Link
                    className={clsx('nav-link text-active-primary me-4', {
                      active: activeTab === 'team',
                    })}
                    to=''
                    onClick={() => handleTabClick('team')}
                  >
                    Team Attendence (Legacy)
                  </Link>
                </li>
              )}
            </ul>
            <Button
              className='ms-auto my-auto me-3'
              onClick={() => {
                setShowForm(true)
              }}
              hidden={!checkRole(['attendance_management_system'], roleState.features)}
            >
              Upload Attendence
            </Button>
          </div>
        </div>
      </div> */}
      <div className='row justify-content-center'>
        {/* Always show Enhanced Attendance Management */}
        <EnhancedAttendanceManagement />
        
        {/* Legacy components hidden as requested */}
        {/* {activeTab === 'enhanced' ? (
          <EnhancedAttendanceManagement />
        ) : activeTab === 'self' ? (
          <Attendance data={attendence} setData={setAttendence} />
        ) : (
          <AdminAttendance data={attendence} setData={setAttendence} />
        )} */}
        {/* Example: Gate an Add Record / Upload legacy feature if brought back */}
        {/* <FeatureGate feature={FEATURE_KEYS.ams_add_record}>
          <Button className='ms-auto my-auto me-3' onClick={() => setShowForm(true)}>Add Record</Button>
        </FeatureGate> */}
      </div>
    </div>
  )
}

export default AmsLayout
